import type { IJupiterAppProps } from '@modules/Jupiter';
import { HttpBase } from '@library/Security';
import type { IAuthenticationResponse } from './IAuthenticationResponse';

export const useAuthenticationApi = () => new AuthenticationApi();

export class AuthenticationApi extends HttpBase
{
    
    /**
     * Authenticates the user with attribues provided by Jupiter in the webview querystring
     * @param params 
     * @returns 
     */
    async authenticateAsync( params: IJupiterAppProps ): Promise<IAuthenticationResponse|null>
    {
        const result = await this.post( `api/authentication/login`, params );
        if( result.success ) return result.data;
        return null;
    }

}


